import { INK } from '../timelineDiagramGeometry'

export const ARROWHEAD_MARKER_ID = 'timeline-arrowhead'
// Reference both fork arms and branchpoint rises point their `markerEnd` at.
export const ARROWHEAD_MARKER_URL = `url(#${ARROWHEAD_MARKER_ID})`

// The arrowhead capping every branch/branchpoint line where its own timeline
// runs off the page.
export const ArrowheadMarker = () => (
  <marker
    id={ARROWHEAD_MARKER_ID}
    markerWidth={7}
    markerHeight={7}
    refX={5}
    refY={3.5}
    orient="auto"
    markerUnits="strokeWidth"
  >
    <path d="M0,0 L7,3.5 L0,7 Z" fill={INK} />
  </marker>
)
